/**
 * Utilitários para manipulação e formatação de preços
 */

/**
 * Formata o preço no padrão brasileiro (R$ 00,00 ou R$ 1.000,00)
 * @param {number} valor - Valor a ser formatado
 * @returns {string} Valor formatado no padrão brasileiro
 */
export const formatarPreco = (valor) => {
  if (valor === undefined || valor === null) return 'R$ 0,00';
  return valor.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

/**
 * Calcula o valor total de um conjunto de serviços
 * @param {Array} servicosIds - Array de IDs de serviços
 * @param {Array} servicesData - Array de dados de serviços com preços
 * @returns {number} Valor total calculado
 */
export const calculateTotalValue = (servicosIds, servicesData) => {
  if (!servicosIds || !servicosIds.length || !servicesData || !servicesData.length) {
    return 0;
  }
  
  return servicosIds.reduce((total, serviceId) => {
    const service = servicesData.find(s => s.id === serviceId);
    return total + (service?.preco || 0);
  }, 0);
}; 